export default __webpack_public_path__ + "static/free-trial-bunny-rocket-3d65c65c5537852372833dca04418e49.svg";